// TD Buy Now Button

if (!customElements.get('td-checkout-button')) {
  class TdCheckoutButton extends HTMLElement {
    constructor() {
      super();
      this._onClick = this.onClick.bind(this);
      this._onVariantChange = this.onVariantChange.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('[data-checkout-button]');
      this.form = this.dataset.formId ? document.getElementById(this.dataset.formId) : null;

      if (!this.button) return;

      if (!this.form) {
        // No main CTA form on the page — nothing to submit.
        this.button.disabled = true;
        this.button.setAttribute('aria-disabled', 'true');
        return;
      }

      this.button.addEventListener('click', this._onClick);
      document.addEventListener('variant:changed', this._onVariantChange);
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this._onClick);
      document.removeEventListener('variant:changed', this._onVariantChange);
    }

    onVariantChange(evt) {
      const variant = evt.detail && evt.detail.variant;
      const unavailable = !variant || !variant.available;
      this.button.disabled = unavailable;
      this.button.setAttribute('aria-disabled', unavailable.toString());
    }

    onClick(evt) {
      evt.preventDefault();
      if (this.button.getAttribute('aria-disabled') === 'true' || this.button.disabled) return;

      this.button.setAttribute('aria-busy', 'true');

      const formData = new FormData(this.form);
      // Option inputs (if any) are not valid cart/add params.
      formData.delete('option1');
      formData.delete('option2');
      formData.delete('option3');

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const cartAddUrl = (window.themeVariables && window.themeVariables.routes.cartAddUrl) || `${root}cart/add`;
      const checkoutUrl = `${root}checkout`;

      fetch(`${cartAddUrl}.js`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      })
        .then((response) => {
          if (!response.ok) {
            return response.json().then((data) => {
              throw new Error(data.description || data.message || 'Add to cart failed');
            });
          }
          return response.json();
        })
        .then(() => {
          window.location.href = checkoutUrl;
        })
        .catch((e) => {
          console.error('Checkout button add-to-cart error:', e);
          this.button.removeAttribute('aria-busy');
        });
    }
  }

  customElements.define('td-checkout-button', TdCheckoutButton);
}
